/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BaseResponse } from '../models/base-response';
import { LicenseResponse } from '../models/license-response';
import { nxLicenseControllerGetLicenseData } from '../fn/nx-license/nx-license-controller-get-license-data';
import { NxLicenseControllerGetLicenseData$Params } from '../fn/nx-license/nx-license-controller-get-license-data';

@Injectable({ providedIn: 'root' })
export class NxLicenseService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `nxLicenseControllerGetLicenseData()` */
  static readonly NxLicenseControllerGetLicenseDataPath = '/nx-license/license';

  /**
   * Restituisce la licenza.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `nxLicenseControllerGetLicenseData()` instead.
   *
   * This method doesn't expect any request body.
   */
  nxLicenseControllerGetLicenseData$Response(params?: NxLicenseControllerGetLicenseData$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: LicenseResponse;
}>> {
    return nxLicenseControllerGetLicenseData(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce la licenza.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `nxLicenseControllerGetLicenseData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  nxLicenseControllerGetLicenseData(params?: NxLicenseControllerGetLicenseData$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: LicenseResponse;
}> {
    return this.nxLicenseControllerGetLicenseData$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: LicenseResponse;
}>): BaseResponse & {
'data'?: LicenseResponse;
} => r.body)
    );
  }

}
